import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import Editor from '../../../../../components/editor/Editor';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { generateFileUrlSegment } from '../../../../../utils/utils';
import { StepProps } from './AddEditFeaturedIngredient';

export const FeaturedIngredientForm = ({
  touched,
  errors,
  values,
  setFieldValue,
  featuredIngredient,
  readOnly
}: StepProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0] || null;
    setFieldValue?.('image', file);
  };

  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Featured Ingredient Details" showRequiredLegend={!readOnly} />
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="name"
        >
          <FormLabel required>Name</FormLabel>
          <Field
            name="name"
            type="text"
            as={Form.Control}
            isInvalid={touched.name && !!errors.name}
            aria-required
          />
          <ErrorMessage name="name">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>

      <Col
        xs={12}
        lg={12}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-10"
          controlId="details"
        >
          <FormLabel required>Content</FormLabel>
          <Field
            name="content"
            component={Editor}
            className="form-control"
            isInvalid={touched.content && !!errors.content}
            aria-required
          />
          <ErrorMessage name="content">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>

      <Col
        xs={12}
        lg={12}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-10"
          controlId="details"
        >
          <FormLabel>Uncovering instructions</FormLabel>
          <Field
            name="uncovering_instructions"
            component={Editor}
            className="form-control"
          />
        </Form.Group>

        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="total"
        >
          <FormLabel>File</FormLabel>
          <Field
            name="file_name"
            type="file"
            as={Form.Control}
            onChange={handleFileChange}
            isInvalid={touched.image && !!errors.image}
          />
          <ErrorMessage name="document">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
        {featuredIngredient && (
          <Row>
            <Col>
              <img
                src={`${generateFileUrlSegment(featuredIngredient.id, featuredIngredient.s3_base_url, 'thumb')}/${featuredIngredient.image_file_name}`}
                alt={featuredIngredient.name}
                className="image-recipe"
              />
            </Col>
          </Row>
        )}
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="name"
        >
          <FormLabel>Image source</FormLabel>
          <Field
            name="image_source"
            type="text"
            as={Form.Control}
            isInvalid={touched.image_source && !!errors.image_source}
          />
          <ErrorMessage name="image_source">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
    </Row>
  );
};
